export default "__VITE_ASSET__32c6acf5__"